const _excluded = ["style", "className", "children", "disabled", "size", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { variantSwitch } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import BasicButton from './BasicButton';
import { buttonTypePropType } from '../consts';
const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium'
};
/**
 * Link Button.
 */
const LinkButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      children,
      disabled,
      size = BUTTON_SIZES.MEDIUM,
      onClick
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    ref: ref,
    className: className,
    disabled: disabled,
    onClick: onClick,
    style: [{
      color: theme.tokens.colors.text.link.value,
      padding: 0,
      '&:hover': {
        color: theme.tokens.colors.text.hover.value
      },
      '&:focus': {
        color: theme.tokens.colors.text.link.value,
        boxShadow: theme.halos.focus
      },
      '&:active': {
        boxShadow: 'none',
        color: theme.tokens.colors.text.pressed.value
      },
      '&[disabled]': {
        color: theme.tokens.colors.text.inactive.value,
        cursor: 'not-allowed'
      }
    }, variantSwitch({
      statement: size,
      variants: {
        [BUTTON_SIZES.SMALL]: theme.typography.bodySmall,
        [BUTTON_SIZES.MEDIUM]: theme.typography.bodyMedium
      }
    }), style]
  }, props), children);
});
LinkButton.displayName = 'LinkButton';
LinkButton.propTypes = {
  /** LinkButton's content */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /**  The size of the button, defaults to 'medium' */
  size: PropTypes.oneOf(Object.values(BUTTON_SIZES)),
  /** button html type, eg: submit */
  type: buttonTypePropType,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onclick event for button */
  onClick: PropTypes.func
};
export default Object.assign(LinkButton, {
  SIZES: BUTTON_SIZES
});
//# sourceMappingURL=LinkButton.js.map